import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Main } from '../../Components'
import { reset } from '../../Redux/features/authSlice'
import { ReactComponent as Logo } from './../../assets/logo/logo.svg'

export function Logout() {

	const [isLoading, setIsLoading] = useState(true)
	const { user , org } = useSelector((state) => state.auth)
	const [sessionToken, setSessionToken] = useState(user?.token)
	const navigate = useNavigate()

	const dispatch = useDispatch();

	useEffect(() => {
		
		if (user && user.token && org && org?.id ) {
			
			const token = user?.token;
			setSessionToken(token)

			// ! Remove the local storage of auth inforamtion 
			// localStorage.removeItem(`${process.env.REACT_APP_STORAGE_AUTH_USER}`)
			// localStorage.removeItem(`${process.env.REACT_APP_STORAGE_AUTH_ORG}`)

			// ! remove the redux auth information
			dispatch(reset()) 

			setIsLoading(false)

		}


	}, [])


	useEffect(() => {
		if(sessionToken === null  ){
			navigate(`/login`);
		}
	 
	}, [sessionToken])
	
	


	return (
		<>
		<Helmet>
			<title>Logout</title>
		</Helmet>
		<Main size={`full`} withNav={false} positionY="top"  >
			<div className="layout-login-form">
				<div className="logo-wrapper">
					<Logo />
				</div> 
				{
					isLoading === true 
					? <div >Logout in progress...</div>
					: <div >Redirecting to login page...</div>
				}
				
			</div>
		</Main>
		</>
	)
}
